// ECMJ - gidan.kang
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactComponent as IconPoint } from '@ecp/common/src/assets/icon/icon__asset-welpoint.svg';
import { ASSET_RESOURCE_DIVISION_CODE, ASSET_RESOURCE_DIVISION_NAME } from '@ecp/common/src/const/asset';

import myAssetPointApi from '@fo-apis/myPage/myAssetPointApi';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import useAssetPoint from '@ecp/common/src/hooks/asset/useAssetPoint';
import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';
import { NumberFormat } from '@ecp/common/src/utils/utils';
import { SiteNumberFunc } from '@ecp/common/src/const/site/siteNumberConst';
import GnbIconButton2 from '@fo-pages/home/gnb/GnbIconButton2';

const GnbPointWel = ({ to }) => {
  const location = useLocation();
  const { priceFormat, siteNumber } = useSiteInfo();
  const { getAssetUnit } = useAssetPoint();
  const priceUtils = new PriceUtils();

  const [point, setPoint] = useState([]);

  const pointCode = ASSET_RESOURCE_DIVISION_CODE.WEL_POINT; // 웰포인트
  const displayPointName = useMemo(() => {
    return SiteNumberFunc.welPointName(siteNumber) ?? ASSET_RESOURCE_DIVISION_NAME[pointCode];
  }, [siteNumber]);

  const fetchMySummary = useCallback(async () => {
    const { result } = await myAssetPointApi.summary();

    const supportPoint = result
      .filter((item) => item.assetResourceDivisionCode === pointCode)
      .map((item) =>
        item.assetResourceDivisionCode === pointCode
          ? { ...item,
            assetDivisionName: displayPointName,
            displayAssetBalance: priceUtils.getDisplayPrice({
              priceFormat,
              price: NumberFormat(item.assetBalance ?? 0),
              formattedPrice: NumberFormat(item.assetFormattedBalance ?? 0),
            })}
          : item
      )[0];
    setPoint(supportPoint);
  }, []);

  useEffect(() => {
    (async () => await fetchMySummary())();
  }, [location.pathname]);

  return (
    <GnbIconButton2
      iconType={IconPoint}
      label={point?.assetDivisionName ?? displayPointName}
      iconCount={point?.displayAssetBalance ?? 0}
      to={to}
      data-ds-label2={'g_point'}
      unit={getAssetUnit(point?.assetResourceDivisionCode)}
    />
  );
};

export default GnbPointWel;

GnbPointWel.propTypes = {
  to: PropTypes.string,
};
